import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {AutofocusDirective} from '../../../../../common/directive/autofocus.directive';
import {NgClass, NgIf} from '@angular/common';

@Component({
  selector: 'app-form-checkbox',
  imports: [
    ReactiveFormsModule,
    AutofocusDirective,
    NgIf,
    NgClass
  ],
  templateUrl: './checkbox.component.html',
})
export class CheckboxComponent {

  @Input()
  formGroup: FormGroup;

  @Input()
  name: string;

  @Input()
  label: string

  @Input()
  big = false

  @Input()
  tabIndex = 0

  @Input()
  autoFocus = false

  @Input()
  black= false

  @Input()
  choiceValue: string

  @Input()
  multiChoices = false

  @Input()
  multiValues = false

  @Output()
  onChange = new EventEmitter();

  @Output()
  onChangeOption = new EventEmitter();

}
